import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const items = [
    {
        q: "Apa itu PUSATCUAN dan mengapa disebut platform hiburan digital terbaik?",
        a: "PUSATCUAN adalah platform hiburan digital & situs hiburan no 1 Indonesia yang menyediakan akses game online terbaru melalui link resmi terpercaya. Didukung keamanan tingkat tinggi dan layanan 24 jam, PUSATCUAN menjadi pilihan utama pemain yang mencari situs game online terpercaya.",
    },
    {
        q: "Bagaimana cara mendapatkan link resmi terpercaya PUSATCUAN?",
        a: "Link resmi terpercaya PUSATCUAN dapat diakses langsung dari halaman utama situs ini. Kami menyediakan alternatif multi-link anti blokir agar akses ke pusatcuan slot dan seluruh game online terbaru tetap lancar kapan pun.",
    },
    {
        q: "Apakah pusatcuan slot aman dan terpercaya?",
        a: "Ya. Pusatcuan slot menggunakan sistem enkripsi tingkat tinggi, audit transaksi real-time, serta tim CS profesional 24/7 — menjadikannya situs hiburan online terpercaya pilihan banyak member di Indonesia.",
    },
    {
        q: "Berapa lama proses transaksi di PUSATCUAN?",
        a: "Rata-rata proses deposit dan withdrawal selesai di bawah 3 menit berkat integrasi langsung dengan bank lokal, e-wallet (DANA, OVO, GoPay, LinkAja, ShopeePay), serta pulsa tanpa potongan.",
    },
    {
        q: "Apa keunggulan PUSATCUAN dibanding situs game online lain?",
        a: "PUSATCUAN menggabungkan katalog game online terbaru, RTP transparan, bonus premium harian, serta dukungan provider lisensi resmi — menjadikannya platform hiburan digital terbaik untuk hiburan online terpercaya.",
    },
    {
        q: "Apakah ada aplikasi mobile?",
        a: "PUSATCUAN dapat diakses melalui browser di semua perangkat (Android, iOS, Desktop) tanpa perlu install aplikasi tambahan. Tampilan responsif memastikan pengalaman optimal.",
    },
];

export default function FAQ() {
    const [open, setOpen] = useState(0);
    return (
        <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
            <div className="max-w-4xl mx-auto px-6 md:px-12">
                <div className="text-center">
                    <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                        Pertanyaan Umum
                    </span>
                    <h2 className="mt-4 text-3xl md:text-5xl font-medium tracking-tighter text-white">
                        FAQ <span className="text-gold-gradient">PUSATCUAN</span>
                    </h2>
                    <p className="mt-4 text-white/60">
                        Jawaban atas pertanyaan tentang pusatcuan, pusatcuan slot, dan
                        link resmi terpercaya.
                    </p>
                </div>

                <div className="mt-12 divide-y divide-white/5 border-y border-white/5">
                    {items.map((it, i) => {
                        const isOpen = open === i;
                        return (
                            <div key={i} data-testid={`faq-item-${i}`}>
                                <button
                                    type="button"
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    className="w-full flex items-center justify-between text-left py-6 group"
                                    data-testid={`faq-question-${i}`}
                                    aria-expanded={isOpen}
                                >
                                    <span className="text-base md:text-lg font-medium text-white pr-6 group-hover:text-[#D4AF37] transition-colors">
                                        {it.q}
                                    </span>
                                    <span className="shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/10 text-white/60 group-hover:border-[#D4AF37]/50 group-hover:text-[#D4AF37]">
                                        {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                                    </span>
                                </button>
                                <div
                                    data-testid={`faq-answer-${i}`}
                                    className={`grid transition-all duration-300 ease-out ${
                                        isOpen
                                            ? "grid-rows-[1fr] opacity-100 pb-6"
                                            : "grid-rows-[0fr] opacity-0"
                                    }`}
                                >
                                    <div className="overflow-hidden">
                                        <p className="text-white/65 leading-relaxed max-w-3xl">
                                            {it.a}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
